module.exports = __webpack_public_path__ + "img/expostyle_0064_electric_blue_pantone7685c.29f3e2a3.jpg";